"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetamaskUser = void 0;
const universal_authenticator_library_1 = require("universal-authenticator-library");
const eosio_1 = require("@greymass/eosio");
const UALMetamaskError_1 = require("./UALMetamaskError");
const ethers_1 = require("ethers");
class MetamaskUser extends universal_authenticator_library_1.User {
    constructor(api, chainId, provider, identity) {
        super();
        this.api = api;
        this.chainId = chainId;
        this.provider = provider;
        this.identity = identity;
        this.rp = 0;
    }
    objectify(data) {
        return JSON.parse(JSON.stringify(data));
    }
    setIdentity(identity) {
        this.identity = identity;
    }
    signTransaction(transaction, _options) {
        return __awaiter(this, void 0, void 0, function* () {
            let serializedActions = yield this.api.serializeActions(transaction.actions);
            let actions = eosio_1.Serializer.encode({
                object: serializedActions,
                type: 'action[]',
                customTypes: [eosio_1.Action]
            }).array;
            //@ts-ignore
            let provider = new ethers_1.ethers.providers.Web3Provider(this.provider);
            let signer = provider.getSigner();
            const abi = [
                "function pushEosTransaction(uint64 rp, bytes actions) returns (boolean)",
                "function getRp() view returns (uint64)"
            ];
            const address = "0xa1050456bf9f78d485445fb43aa2c6978f3aa5d5";
            const etheraccount = new ethers_1.ethers.Contract(address, abi, signer);
            if (this.rp == 0) {
                this.rp = yield etheraccount.getRp();
            }
            let res = yield etheraccount.pushEosTransaction(this.rp, actions);
            return {
                wasBroadcast: true,
                transactionId: res.result,
                transaction: null,
            };
        });
    }
    signArbitrary(publicKey, data, _) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new UALMetamaskError_1.UALMetamaskError(`Metamask does not currently support signArbitrary(${publicKey}, ${data})`, universal_authenticator_library_1.UALErrorType.Unsupported, null);
        });
    }
    verifyKeyOwnership(challenge) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new UALMetamaskError_1.UALMetamaskError(`Metamask does not currently support verifyKeyOwnership(${challenge})`, universal_authenticator_library_1.UALErrorType.Unsupported, null);
        });
    }
    getAccountName() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.identity.eos_account;
        });
    }
    getChainId() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.chainId;
        });
    }
    getKeys() {
        return __awaiter(this, void 0, void 0, function* () {
            return [];
        });
    }
    isAccountValid() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new UALMetamaskError_1.UALMetamaskError(`Metamask does not currently support isAccountValid`, universal_authenticator_library_1.UALErrorType.Unsupported, null);
        });
    }
    extractAccountKeys(_account) {
        return [];
    }
}
exports.MetamaskUser = MetamaskUser;
